import TopMenu from "../features/top-menu/Top-menu";
import RightMenu from "../components/Right-menu";
import {Outlet} from "react-router-dom";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import WelcomePopup from "../components/WelcomePopup";
import {useSelector} from "react-redux";
import {selectShowEditForm, selectShowHistory} from "../features/common-states/commonStatesSlice";
import {selectShowUserPasswordForm} from "../features/user/userSlice";

const Home = () => {
    const navigate = useNavigate();
    const showEditForm = useSelector(selectShowEditForm)
    const showHistory = useSelector(selectShowHistory)
    const showUserPasswordForm = useSelector(selectShowUserPasswordForm)

    useEffect(() => {
        if(showEditForm === true || showHistory === true || showUserPasswordForm === true){
            window.scrollTo(0, 0)
        }
    }, [showEditForm, showHistory, showUserPasswordForm])

    useEffect(() => {
        navigate('applicant')
        // eslint-disable-next-line
    }, [])
    return(
        <div className='home'>
            <WelcomePopup />
            <TopMenu />
            <div className='main-section'>
                <div className='user-section'>
                    <Outlet />
                </div>
                <RightMenu />
            </div>
        </div>
    )
}

export default Home